<div class="_container wrap p-t-15 p-b-20 p-t-5-s p-t-10-m p-b-5-m p-b-4-s">
    <div style="max-width: 740px; width: inherit;">
        @if(typeData) {
        <h1 class="h1"
            *iCms="'title' of typeData"></h1>
        <p class="p1 m-t-2"
           *iCms="'copy' of typeData"></p>
        }
        @if (model?.children?.length ) {
        <div class="m-t-8 m-t-5-s _grid">
            @for (child of children; track child) {
            <a class="block bg-col-w _itemBig center p-t-10 p-b-10 p-t-5-s p-b-5-s"
               [class]="isSmallItem($index) ? '_itemSmall' : '_itemBig'"
               [routerLink]="child.data?.url">
                <i style="font-size: 40px;"
                   [class]="child.data?.typeData.icon || ''"></i>
                <p class="m-t m-t-2-s s1">{{child.data?.name}}</p>
                <button class="col-11-s col-11-m p1-s p1-m s1 m-t-1-x m-t-1-l link">{{'view more' | translate}}</button>
            </a>
            }
        </div>
        }
    </div>
</div>
@if(typeData) {
<!-- <icms-outlet [components]="components"></icms-outlet> -->
<icms-outlet-block [name]="'Information content'" />
}